export default function checkObject(t) {
    var e = typeof t;
    return e === "object" && t !== null || e === "function";
}
//# sourceMappingURL=checkObject.js.map
